import { DropdownList } from '@cancercentrum/rcc-react';
import type { ReactElement } from 'react';
import { ecogFormatter, valueAndTextFormatter } from '../../utils/formatters.tsx';

export const EcogDropdownList = (props: any): ReactElement => {
    return (
        <DropdownList {...props} formatter={ecogFormatter} formatterText={valueAndTextFormatter} searchable={false} />
    );
};
